<template>
  <b-modal refs="slicer-3-modal"
           v-model="showLocal"
           class="slicer-3"
           :class="staticClass"
           modal-class="modal--edit slicer-3"
           :static="staticModal"
           :lazy="false"
           hide-footer
           @shown="handleModalShown"
           @hide="handleModalHide">
    <iframe :id="iframeId" :src="slicerUrl"> </iframe>
  </b-modal>
</template>

<script>
  import {mapGetters} from "vuex";
  import PrinterTypeMixin from "../../../mixins/printerType";

  export default {
    name: "Slicer3",
    mixins: [PrinterTypeMixin],
    props: {
      show: {
        type: Boolean,
        default: false
      },
      fileId: {
        type: [Number, String],
        required: false
      },
      printerTypeId: {
        type: [Number, String],
        required: false
      },
      profileMode: {
        type: Boolean,
        default: false
      },
      profileId: {
        type: [Number, String],
        required: false
      },
      staticModal: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        slicerUrl: '',
        localPrinterTypeId: null,
        iframeId: this.staticModal ? `f${(~~(Math.random()*1e8)).toString(8)}` : null
      }
    },
    created() {
      console.log(this.$locale.current());
      this.definePrinterTypeId();
      var queryStringParams = [];
      if (this.fileId) {
        queryStringParams.push('file_id=' + this.fileId);
      }
      if (this.localPrinterTypeId !== undefined && this.localPrinterTypeId) {
        queryStringParams.push('printer_type_id=' + this.localPrinterTypeId);
      }
      if (this.profileMode) {
        queryStringParams.push('mode=profiler');
      }
      if (this.profileId) {
        queryStringParams.push('profile_id=' + this.profileId);
      }
      if (this.staticModal && !this.show) {
        queryStringParams.push('bi=1');
      }
      if (this.$locale.current()) {
        queryStringParams.push('lang=' + this.$locale.current());
      }

      this.slicerUrl = window.baseURL + '/slicer3?' + queryStringParams.join('&');
    },

    methods:{
      close(){
        this.$emit('hide', false);
      },

      definePrinterTypeId() {
        if (this.printerTypeId) {
          this.localPrinterTypeId = this.printerTypeId;
        } else {
          const primaryPrinterTypeId = this.getPrimaryPrinterTypeId(this.fileId);
          if (primaryPrinterTypeId && this.isPrinterTypeSupportedBySlicer3(primaryPrinterTypeId)) {
            this.localPrinterTypeId = primaryPrinterTypeId;
          }
        }
      },

      handleModalShown() {
        this.checkBodyClass(this.show);
      },

      handleModalHide(e) {
        e.preventDefault();
        this.close();
      },

      checkBodyClass(show) {
        if (this.staticModal) {
          if (show) {
            document.body.className += 'modal-open';
          } else {
            document.body.className = document.body.className.replace('modal-open', '');
          }
        }
      }
    },

    computed:{
      ...mapGetters(['isPrinterTypeSupportedBySlicer3']),

      showLocal: {
        get: function() {
          if (this.staticModal) {
            return true;
          }
          return this.show
        },
        set: function() {
          this.close()
        }
      },

      staticClass() {
        let className = '';
        if (this.staticModal && !this.show) {
          className = 'static-hidden';
        }

        return className;
      }
    },
    watch: {
      printerTypeId: function(val) {
        this.localPrinterTypeId = val;
      },
      show: function(val) {
        if (val && this.staticModal) {
          this.definePrinterTypeId();
          const iframeSlicerInstance = document.getElementById(this.iframeId);
          if (iframeSlicerInstance !== null) {
            iframeSlicerInstance.contentWindow.switchFile(
              this.fileId,
              this.profileMode ? 'profiler' : 'slicer',
              this.localPrinterTypeId,
              this.profileMode ? this.profileId : null,
              true
            );
            this.$nextTick(() => {
              iframeSlicerInstance.contentWindow.init3DViewer();
            });
          }
        }
        this.checkBodyClass(val);
      }
    }
  }
</script>

<style  lang="scss">
  .slicer-3{
    .modal{
      overflow-x: scroll;
    }
    &.static-hidden {
      display: none !important;
      > div {
        display: none !important;
      }
    }
    .modal-dialog{
        width: 90%!important;
        max-width: 994px!important;
        min-width: 994px!important;
        max-height: 800px!important;
    }
    .modal-content{
      height: 640px;
    }

    iframe{
      width: 100%;
      height: 100%;
      border: 0;
      position: absolute;
      left: 0;
      top: 0;
      //padding: 15px;
      border-radius: 8px;
    }
  }

</style>
